/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { useBufferedMeasurements } from '@mpb-com/feather/hooks/use-buffered-mesurements';
import React, { FunctionComponent, useRef } from 'react';

import { CardBackground } from '@toucan/client/shared/components/card-background';
import { renderMarkdown } from '@toucan/client/shared/helpers/markdown';
import { ResponsiveLoaderType } from '@toucan/client/shared/hooks/use-responsive-loader';

import { ResponsiveImage } from '@toucan/client/blocks/components/responsive-image';

import { getHeadingColors, imageSizes } from './helpers';
import { StyledListingTile } from './listing-tile.styles';
import { ListingTileProps } from './types';

export const ListingTile: FunctionComponent<ListingTileProps> = ({
    heading,
    color,
    gridImage,
    gridImageAlt,
}) => {
    const { headingColor, highlightColor } = getHeadingColors(color);
    const listingTileRef = useRef<HTMLDivElement>(null);

    const { measurements, status } = useBufferedMeasurements({
        refs: { container: listingTileRef },
    });

    const image = {
        src: gridImage,
        alt: gridImageAlt,
    };

    return (
        <StyledListingTile
            data-testid="listing-tile"
            ref={listingTileRef}
            measurements={measurements}
            status={status}
        >
            <CardBackground
                className="tile-background"
                color={color}
                expandOnHover={false}
            >
                <div className="tile">
                    <div className="tile-image">
                        <ResponsiveImage
                            alt={image.alt}
                            sizes={imageSizes}
                            fill
                            src={image.src}
                            loader={ResponsiveLoaderType.CONTENTFUL}
                        />
                    </div>
                    <Heading
                        className="tile-heading"
                        size={HeadingSize.H4}
                        color={headingColor}
                        highlightColor={highlightColor}
                    >
                        {renderMarkdown(heading)}
                    </Heading>
                </div>
            </CardBackground>
        </StyledListingTile>
    );
};
